export const SOLUTION_TABS = [
  { key: 'founders', label: 'Founders' },
  { key: 'engineering', label: 'Engineering' },
  { key: 'sales', label: 'Sales' },
  { key: 'hr', label: 'HR' },
  { key: 'operations', label: 'Operations' },
  { key: 'support', label: 'Support' },
];

export const SOLUTIONS = {
  founders: {
    t: 'Run the company on live activity data, not noise',
    d: 'Get every team, department, and the whole company visible in one brain — without a single status meeting.',
    l: [
      'See output patterns across every team',
      'Catch burnout & attrition months early',
      'Replace status meetings with AI briefs',
    ],
    a: [
      ['A', '#F2673A', '<b>Anomaly Agent</b> flags every-7th-day leave patterns'],
      ['S', '#469FD8', "<b>Summary Agent</b> writes the Monday Founder's Report"],
      ['P', '#34A851', '<b>Pulse Agent</b> tracks team energy and focus time'],
      ['Q', '#6C59A6', '<b>Answer Agent</b> handles "how\'s X going?" instantly'],
    ],
  },
  engineering: {
    t: 'Ship predictably, without standup theater',
    d: 'Focus time, review lag, and sprint health measured from real signal — not self-reported updates.',
    l: [
      'Protect deep-focus hours from meeting creep',
      'Spot review bottlenecks the day they form',
      'Forecast sprint slip from live patterns',
    ],
    a: [
      ['F', '#2DBDB8', '<b>Focus Agent</b> guards maker time on the calendar'],
      ['R', '#469FD8', '<b>Review Agent</b> watches PR wait-time drift'],
      ['S', '#8B75D7', '<b>Sprint Agent</b> projects burn from actuals'],
      ['Q', '#6C59A6', '<b>Answer Agent</b> briefs stakeholders instantly'],
    ],
  },
  sales: {
    t: 'Coach from patterns, not gut feel',
    d: 'Reply lag, pipeline touch-time, and follow-up discipline — visible per rep, per account, per week.',
    l: [
      'Cut client reply lag under 2 hours',
      'See which accounts go quiet too long',
      'Pair CRM stages with real activity',
    ],
    a: [
      ['L', '#F2673A', '<b>Lag Agent</b> flags 3-day-old client emails'],
      ['P', '#469FD8', '<b>Pipeline Agent</b> matches effort to deal size'],
      ['C', '#34A851', '<b>Coach Agent</b> spots winning weekly rhythms'],
      ['S', '#8B75D7', '<b>Summary Agent</b> writes the Friday pipeline brief'],
    ],
  },
  hr: {
    t: 'See culture in the data, early',
    d: 'Attendance rhythms, engagement drift, and burnout risk — surfaced with dignity, without surveillance.',
    l: [
      'Catch attrition risk months earlier',
      'Understand leave & attendance patterns',
      'Prove culture wins with real numbers',
    ],
    a: [
      ['W', '#F2673A', '<b>Wellbeing Agent</b> watches after-hours creep'],
      ['A', '#6C59A6', '<b>Attendance Agent</b> reads leave rhythms'],
      ['E', '#2DBDB8', '<b>Engagement Agent</b> tracks team energy'],
      ['R', '#469FD8', '<b>Report Agent</b> drafts the monthly people review'],
    ],
  },
  operations: {
    t: 'One dashboard for how work flows',
    d: 'Utilization, tool sprawl, and process drag measured continuously across every department.',
    l: [
      'Find the hours lost between tools',
      'Balance workload before teams tip over',
      'Standardize reporting without the chase',
    ],
    a: [
      ['U', '#469FD8', '<b>Utilization Agent</b> maps capacity in real time'],
      ['T', '#34A851', '<b>Tooling Agent</b> spots redundant app spend'],
      ['W', '#F2673A', '<b>Workload Agent</b> warns on overload early'],
      ['S', '#8B75D7', '<b>Summary Agent</b> compiles the ops weekly'],
    ],
  },
  support: {
    t: 'Protect the team behind the queue',
    d: 'Ticket load, response health, and agent energy in one view — quality and wellbeing together.',
    l: [
      'Balance queues before burnout hits',
      'Keep response times honest, hourly',
      'Tie CSAT to real workload data',
    ],
    a: [
      ['Q', '#2DBDB8', '<b>Queue Agent</b> rebalances load across shifts'],
      ['R', '#F2673A', '<b>Response Agent</b> tracks reply-time drift'],
      ['E', '#6C59A6', '<b>Energy Agent</b> watches per-agent strain'],
      ['S', '#469FD8', '<b>Summary Agent</b> writes the support digest'],
    ],
  },
};
